import consumer from "./consumer";

let accountOrderSubscription = null;

document.addEventListener("turbo:load", () => {
  const accountId = document.body.dataset.notificationsAccountIdValue;

  // Evita duplicar suscripciones
  if (accountId && !accountOrderSubscription) {
    accountOrderSubscription = consumer.subscriptions.create(
      { channel: "AccountOrderPaidChannel" },
      {
        received(data) {
          if (data.type === "update_order_state") {
            const orderElement = document.querySelector(`#order-${data.order_id}`);
            if (orderElement) {
              // Update status pill from pending to delivered
              const statusPill = orderElement.querySelector(".order-receipt__status-pill");
              if (statusPill) {
                statusPill.classList.remove("order-receipt__status-pill--pending");
                statusPill.classList.add("order-receipt__status-pill--delivered");
                statusPill.innerHTML = '<i class="fas fa-circle"></i> Entregado';
              }

              // Hide the footer containing the QR code
              const footer = orderElement.querySelector(".order-receipt__footer");
              if (footer) {
                footer.style.display = "none";
              }
            }
          }
        }
      }
    );
  }
});

document.addEventListener("turbo:before-cache", () => {
  if (accountOrderSubscription) {
    consumer.subscriptions.remove(accountOrderSubscription);
    accountOrderSubscription = null;
  }
});
